import { render, staticRenderFns } from "./Case-Header-About.vue?vue&type=template&id=16f3f33e&scoped=true"
import script from "./Case-Header-About.vue?vue&type=script&lang=js"
export * from "./Case-Header-About.vue?vue&type=script&lang=js"
import style0 from "./Case-Header-About.vue?vue&type=style&index=0&id=16f3f33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3f33e",
  null
  
)

export default component.exports